import type { CircleActionVariant } from "components/ui/v2/circle-action-variants";

export function getSkillLevelStyling(level: number) {
  switch (level) {
    case 1:
      return { statusBar: "bg-yellow-500" };
    case 2:
      return { statusBar: "bg-blue-500" };
    case 3:
      return { statusBar: "bg-green-500" };
    case 4:
      return { statusBar: "bg-purple-500" };
    default:
      return { statusBar: "bg-gray-500" };
  }
}

export function getSkillLevelLabel(level: number): string {
  switch (level) {
    case 1:
      return "Junior";
    case 2:
      return "Semi-Senior";
    case 3:
      return "Senior";
    case 4:
      return "Expert";
    default:
      return "Trainee";
  }
}

export function getSkillLevelBadgeVariant(level: number): CircleActionVariant {
  switch (level) {
    case 1:
      return "gold";
    case 2:
      return "sky";
    case 3:
      return "emerald";
    case 4:
      return "violet";
    default:
      return "slate";
  }
}
